import { render, staticRenderFns } from "./ClienteDatos.vue?vue&type=template&id=519fdf96"
import script from "./ClienteDatos.vue?vue&type=script&lang=js"
export * from "./ClienteDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports